import React from 'react';
import { Button, CircularProgress } from '@mui/material';
import type { ButtonProps } from '@mui/material';

type StoreDetailsLoadingButtonProps = ButtonProps & {
    loading?: boolean;
};

const StoreDetailsLoadingButton: React.FC<StoreDetailsLoadingButtonProps> = ({ loading, children, ...props }) => (
    <Button
        {...props}
        startIcon={loading ? <CircularProgress size={18} sx={{ color: '#ffffff' }} /> : undefined}
    >
        {children}
    </Button>
);

export default React.memo(StoreDetailsLoadingButton);
